<script>
export default {
  props: ["color"],
};
</script>

<template>
    <svg fill="none" height="37" viewBox="0 0 27 37" width="27" xmlns="http://www.w3.org/2000/svg"><path d="m21.7536 13.5334c2.4731-2.3972 4.0252-5.85435 4.0252-9.69968 0-1.33465-.1874-2.62158-.5342-3.83372h-7.9108c1.0485 1.07416 1.7009 2.58418 1.7009 4.25797 0 3.26118-2.4783 5.90473-5.5347 5.90473s-5.53474-2.64355-5.53474-5.90473c0-1.67379.65247-3.18381 1.70094-4.25797h-7.91077c-.34816 1.21214-.53419 2.50036-.53419 3.83372 0 3.84533 1.55344 7.30248 4.02514 9.69968-3.19062 2.3959-5.24638 6.1484-5.24638 10.3664 0 7.2355 6.0437 13.1002 13.5 13.1002s13.5-5.8647 13.5-13.1002c0-4.218-2.0544-7.9705-5.2464-10.3664zm-8.2549 17.3388c-3.65973 0-6.62712-3.1193-6.62712-6.9685s2.96739-6.9685 6.62712-6.9685c3.6597 0 6.6271 3.1206 6.6271 6.9685s-2.9674 6.9685-6.6271 6.9685z" :fill="color"/></svg>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/participant-numbers/8.vue